// Assumes stock images have a matchRank of 1 or 2 and infographics 3 or 4
export const STOCK_IMAGE_MAX_MATCH_RANK = 2;
